import React from 'react';

import RightCol from './right-col';

import accordian from '../../scripts/accordian';

export default class ElectricGuitars extends React.Component {
  componentDidMount() {
    accordian();
  }

  render() {
    return (
      <div className="electric-guitars">
        <div className="shop">
          <div className="product-nav">
            <ul className="product-nav__list">
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/1-strat-hss.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Stratocaster</h3>
                    </div>
                  </a>
                </div>
              </li>
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/2-telecaster-american-elite.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Telecaster</h3>
                    </div>
                  </a>
                </div>
              </li>
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/3-acoustasonic.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Acoustasonic</h3>
                    </div>
                  </a>
                </div>
              </li>
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/4-jaguar-american.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Jaguar</h3>
                    </div>
                  </a>
                </div>
              </li>
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/5-jazzmaster-american-professional.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Jazzmaster</h3>
                    </div>
                  </a>
                </div>
              </li>
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/6-duosonic.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Duosonic</h3>
                    </div>
                  </a>
                </div>
              </li>
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/7-mustang.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Mustang</h3>
                    </div>
                  </a>
                </div>
              </li>
              <li className="product-nav__list-item">
                <div className="product-nav__img-container">
                  <a href="#" className="product-nav__link">
                    <img
                      src="./images/products/guitars/8-squier.png"
                      alt=""
                      className="product-nav__img"
                    />
                    <div className="product-nav__link-caption">
                      <h3>Squier</h3>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div className="search-results container">
            <div className="category-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb__item">Home</li>
                <li className="breadcrumb__item">Electric Guitars</li>
                <li className="breadcrumb__item">Shop</li>
              </ol>
            </div>
            <div className="category-row">
              <div className="category-heading">
                <h2 className="category-title">Electric Guitars</h2>
                <span className="category-result-count">188 results</span>
              </div>
              <div className="filter-bar">
                Sort by:
                <div className="custom-select">
                  <select className="sort-by">
                    <option value={0}>Please select one</option>
                    <option value={0}>------------------</option>
                    <option value={1}>New Arrivals</option>
                    <option value={2}>Best Sellers</option>
                    <option value={3}>Product Name A-Z</option>
                    <option value={4}>Product Name Z-A</option>
                    <option value={5}>Price High to Low</option>
                    <option value={6}>Price Low to High</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-3-of-12 shop-left-col">
                <div className="product-filters">
                  <div className="accordian">
                    <div className="card">
                      <div className="card-header">
                        <button
                          className="menu-btn product-filters__title active"
                          id="btn1"
                        >
                          Product Categories
                        </button>
                      </div>
                      <div
                        className="collapse show"
                        id="card1"
                        aria-expanded="true"
                      >
                        <div className="card-body product-filters__body">
                          <ul>
                            <li>Electric Guitars</li>
                            <li>Acoustic Guitars</li>
                            <li>Electric Basses</li>
                            <li>Guitar Amplifiers</li>
                            <li>Bass Amplifiers</li>
                            <li>Audio</li>
                            <li>Accessories</li>
                            <li>Lifestyle</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <button
                          className="menu-btn product-filters__title active"
                          id="btn2"
                        >
                          Featured
                        </button>
                      </div>
                      <div
                        className="collapse show"
                        id="card2"
                        aria-expanded="true"
                      >
                        <div className="card-body product-filters__body">
                          <ul>
                            <li>NEW! Vintera Series</li>
                            <li>NEW! American Performer</li>
                            <li>American Original</li>
                            <li>American Professional</li>
                            <li>American Elite</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <button
                          className="menu-btn product-filters__title filter active"
                          id="btn3"
                        >
                          Filters
                        </button>
                      </div>
                      <div
                        className="collapse show"
                        id="card3"
                        aria-expanded="true"
                      >
                        <div className="card-body product-filters__body">
                          <div className="accordian">
                            <div className="card">
                              <div className="card-header">
                                <button
                                  className="menu-btn product-filters__title active"
                                  id="btn4"
                                >
                                  Model
                                </button>
                              </div>
                              <div
                                className="collapse show"
                                id="card4"
                                aria-expanded="true"
                              >
                                <div className="card-body product-filters__body">
                                  <ul>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Stratocaster ® (72)
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Telecaster ®
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Jazzmaster ®
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Jaguar ®
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Mustang ®
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Duo-Sonic ®
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Other
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Starcaster ®
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Jazz Bass ®
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <button
                                  className="menu-btn product-filters__title active"
                                  id="btn5"
                                >
                                  Series
                                </button>
                              </div>
                              <div
                                className="collapse show"
                                id="card5"
                                aria-expanded="true"
                              >
                                <div className="card-body product-filters__body">
                                  <ul>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        American Original
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        American Professional
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        American Elite
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        American Special
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Artist
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Classic
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Deluxe
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Limited Edition
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <button
                                  className="menu-btn product-filters__title active"
                                  id="btn6"
                                >
                                  Orientation
                                </button>
                              </div>
                              <div
                                className="collapse show"
                                id="card6"
                                aria-expanded="true"
                              >
                                <div className="card-body product-filters__body">
                                  <ul>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Right-Handed
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Left-Handed
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <button
                                  className="menu-btn product-filters__title active"
                                  id="btn7"
                                >
                                  Color
                                </button>
                              </div>
                              <div
                                className="collapse show"
                                id="card7"
                                aria-expanded="true"
                              >
                                <div className="card-body product-filters__body">
                                  <ul className="product-filters__color-ul">
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/black.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/blue.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/brown.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/burst.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/gold.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/gray.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/green.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/natural.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/orange.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/pink.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/red.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/silver.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/white.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/yellow.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/blonde.png" />
                                      </a>
                                    </li>
                                    <li className="product-filters__color-li">
                                      <a
                                        className="product-filters__refine-color"
                                        href
                                      >
                                        <img src="./images/products/store/color/other.png" />
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <button
                                  className="menu-btn product-filters__title active"
                                  id="btn8"
                                >
                                  Woods
                                </button>
                              </div>
                              <div
                                className="collapse show"
                                id="card8"
                                aria-expanded="true"
                              >
                                <div className="card-body product-filters__body">
                                  <ul>
                                    <li>Fingerboard Material</li>
                                    <li>Body Material</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <button
                                  className="menu-btn product-filters__title active"
                                  id="btn9"
                                >
                                  Neck Shape
                                </button>
                              </div>
                              <div
                                className="collapse show"
                                id="card9"
                                aria-expanded="true"
                              >
                                <div className="card-body product-filters__body">
                                  <ul>
                                    <li>C Shape</li>
                                    <li>Modern C</li>
                                    <li>D Shape</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header">
                                <button
                                  className="menu-btn product-filters__title active"
                                  id="btn10"
                                >
                                  Pickup Type
                                </button>
                              </div>
                              <div
                                className="collapse show"
                                id="card10"
                                aria-expanded="true"
                              >
                                <div className="card-body product-filters__body">
                                  <ul>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Custom Shop
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Humbucker / Humbucker
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Modern
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Pure Vintage
                                      </a>
                                    </li>
                                    <li>
                                      <a href>
                                        <span className="product-filters__checkbox" />
                                        Single Coil
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-9-of-12 shop-right-col">
                <RightCol />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
